<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">

        <div class="card mb-2" hidden>
          <div class="card-body">
            <h5 class="card-title">Reporte Producción</h5>
            <p class="card-text">Generar reporte de producción general</p>
            <a href="#" class="btn btn-primary">Generar</a>
          </div>
        </div>

        <div class="card mb-2" hidden>
          <div class="card-body">
            <h5 class="card-title">Reporte de operarios</h5>
            <p class="card-text">Genera reporte de las tareas realizadas por operarios.</p>
            <a @click="openModal" class="btn btn-primary">Generar</a>
          </div>
        </div>

        <div class="card mb-2">
          <div class="card-body">
            <h5 class="card-title">Reporte de Insumos</h5>
            <p class="card-text">Genera reporte de las insumos.</p>
            <a :href="`${apiUrl}/export-inventory`" class="btn btn-primary">Generar</a>
          </div>
        </div>

      </div>
    </div>
  </div>


    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Filtrar reporte</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Producción</label>
                <select ref="ProductionSelect" class="form-select select2" multiple style="width:100%;"  >
                  <option v-for="(group) in productions" :key="group?.id" :value="group?.id">
                   #{{ group?.id }} - {{ group?.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Modelo</label>
                <select ref="ModelSelect"  class="form-select select2" multiple style="width:100%;"  >
                  <option v-for="(group) in models" :key="group.id" :value="group.id">
                    Modelo: {{ group?.name }}
                  </option>
                </select>
              </div>
              
              <div class="mb-3">
                <label for="amount" class="form-label">Oficio</label>
                <select  ref="OficioSelect" class="form-select select2" multiple style="width:100%;"  >
                  <option v-for="process in oficios" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Usuario</label>
                <select ref="usersSelect" class="form-select select2" multiple style="width:100%;" >
                  <option v-for="process in users" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="getReport">Generar</button>
          </div>
        </div>
      </div>
    </div>
</template>


<script>

import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';

export default {

  
  name: 'UserList',
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_BASE_URL,
      modalBudget:null,
      filter:{
        production_id:[],
        model_id:[],
        oficio_id:[],
        user_id:[],
      },
      productions:[],
      models:[],
      oficios:[],
      users:[],

    }
  },
  computed: {
  },
  methods: {
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async getProductions() {
      this.productions = await this.$store.dispatch('production/getAll'); 

      console.log(this.productions);
    },
    async getModels() {
      this.models = await this.$store.dispatch('models/getAll'); 
    },
    async getOficios() {
      this.oficios =  await this.$store.dispatch('users/getOficios'); 
    },
    async getUsers() {
      this.users = await this.$store.dispatch('users/getAll');
    },
    async getReport() {
        try {
            // Llamar a la API para obtener el archivo Excel
            const response = await this.$store.dispatch('analitycs/getReportProductionUser',this.filter);
            
            // Crear un objeto URL temporal para el archivo Excel
            const url = window.URL.createObjectURL(new Blob([response.data]));
            
            // Crear un enlace temporal para descargar el archivo
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'production-user-report.xlsx'); // Nombre del archivo
            document.body.appendChild(link);
            link.click();
            link.remove(); // Eliminar el enlace después de la descarga
        } catch (error) {
            console.error('Error al obtener el reporte:', error);
            this.$toast.error('Hubo un error al generar el reporte'); // Mensaje de error (si usas un sistema de notificaciones)
        }
    }
  },
  mounted() {
    this.getProductions();
    this.getModels();
    this.getOficios();
    this.getUsers();

    this.$nextTick(() => {
      $(this.$refs.ProductionSelect).select2({
        placeholder: 'Seleccionar Produccion',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.ProductionSelect).on('change', () => {
        this.filter.production_id = $(this.$refs.ProductionSelect).val();
      });

      $(this.$refs.ModelSelect).select2({
        placeholder: 'Seleccione un Modelo',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.ModelSelect).on('change', () => {
        this.filter.model_id = $(this.$refs.ModelSelect).val();
      });

      $(this.$refs.OficioSelect).select2({
        placeholder: 'Seleccione Oficio',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.OficioSelect).on('change', () => {
        this.filter.oficio_id = $(this.$refs.OficioSelect).val();
      });

      $(this.$refs.usersSelect).select2({
        placeholder: 'Seleccione un usuario',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.usersSelect).on('change', () => {
        this.filter.user_id = $(this.$refs.usersSelect).val();
      });

    });


  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}
</style>